import React, { useState, useEffect } from 'react';
import { ReactSelect } from 'components/FormHelpers/FormInputs';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { TE } from 'appconstants';

const CountryPicker = ({
  allCountries,
  onChanged,
  selCountry,
  name,
  validators,
  errorMessages,
  isDisabled
}) => {
  const [countries, setCountries] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    const allCountrySuggestions = allCountries.map(el => ({
      value: el.code,
      label: `${el.code}-${el.name}`,
      name: el.name
    }));
    setCountries(allCountrySuggestions);
    setSuggestions(allCountrySuggestions);
  }, [allCountries, setCountries, setSuggestions]);


  useEffect(() => {
    const initValue = countries && _.find(countries, (item) => selCountry === item.value);
    setSelected(initValue);
  }, [setSelected, selCountry, countries]);

  const handleInputChange = val => {
    const lcVal = val && val.toLowerCase();
    setSuggestions(_.filter(countries, (item) => item.label.toLowerCase().includes(lcVal)));
  };

  return (
    <ReactSelect
      title="Country Selector"
      name={name}
      isClearable
      data-id={`${TE.ID}${name}${TE.SELECT}`}
      validators={isDisabled ? [] : (validators || [])}
      errorMessages={isDisabled ? [] : (errorMessages || [])}
      options={suggestions}
      value={selected || ''}
      onInputChange={handleInputChange}
      onChange={event => {
        setSelected(event);
        onChanged(name, event);
      }}
      disabled={isDisabled}
    />
  );
};


const withConnectState = connect(
  (state, ownProps) => ({
    allCountries: state.common.countries
  }),
  dispatch => bindActionCreators({}, dispatch)
);


const CntrySelector = ({
  allCountries,
  ...rest
}) => {
  if (_.isUndefined(allCountries)) return (<>Loading Countries</>);
  return (
    <CountryPicker {...rest} allCountries={allCountries} />
  );
};


const CountrySelector = compose(
  withConnectState
)(CntrySelector);

CountrySelector.propTypes = {
  onChanged: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
};

CountrySelector.defaultProps = {
  onChanged: null,
  name: null
};


export default CountrySelector;
